import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useGlobalDispatch } from "./global-context";

export const useHGlobalController = () => {
    const globalDispatch = useGlobalDispatch();
    async function getData() {
        try {
            const applicationData = await BaseAppService.requestApplicationData();
            globalDispatch({
                type: ACTION_TYPES.setApplicationData,
                payload: applicationData,
            });

            const menus = await BaseAppService.requestMenus();
            globalDispatch({
                type: ACTION_TYPES.setMenus,
                payload: menus,
            });

            const parametersPortal = await PortalAppService.getParameters();
            globalDispatch({
                type: ACTION_TYPES.setParametersPortal,
                payload: parametersPortal,
            });
        } catch (error: any) {
            console.error('Error loading application data:', error);

            // Extract status code and message from error
            const statusCode = error?.response?.status || error?.statusCode;
            const message = error?.response?.data?.message || error?.message || 'Erro desconhecido';

            globalDispatch({
                type: ACTION_TYPES.setError,
                payload: {
                    statusCode,
                    message,
                },
            });
        }
    }

    return {
        getData
    };
}